module.exports = __webpack_public_path__ + "img/open-menu.85a1793e.svg";